import React from 'react';

const ItemListActiveIcon = ({ size = '25px', color = '#fff' }) => {
  return (
    <svg
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 208.000000 208.000000'
      preserveAspectRatio='xMidYMid meet'
    >
      <g
        transform='translate(0.000000,208.000000) scale(0.100000,-0.100000)'
        fill={color}
        stroke='none'
      >
        <path
          d='M964 2061 c-32 -15 -47 -30 -70 -77 l-30 -59 -87 -3 -87 -3 0 -129 0
-130 350 0 350 0 0 130 0 129 -87 3 -88 3 -22 44 c-29 57 -51 81 -90 97 -44
19 -90 17 -139 -5z'
        />
        <path
          d='M325 1748 c-11 -6 -28 -20 -37 -32 -16 -19 -18 -78 -18 -829 0 -890
-4 -839 61 -873 40 -20 1362 -21 1412 0 71 29 67 -25 67 873 0 750 -2 810 -18
829 -30 38 -56 44 -190 44 l-130 0 -3 -78 c-3 -47 -10 -86 -18 -95 -12 -15
-53 -17 -412 -17 l-398 0 -15 22 c-11 15 -16 46 -16 95 l0 73 -132 0 c-77 0
-141 -5 -153 -12z m493 -360 c27 -27 11 -54 -89 -148 -152 -142 -136 -138
-220 -53 -62 61 -71 74 -65 97 11 43 50 35 101 -21 l43 -47 97 92 c54 51 103
92 109 92 7 0 17 -5 24 -12z m817 -157 c3 -10 3 -26 -1 -35 -6 -15 -37 -16
-342 -14 -316 3 -337 4 -340 21 -9 48 -14 47 342 47 317 0 335 -1 341 -19z
m-817 -273 c24 -24 11 -49 -65 -121 -128 -122 -147 -137 -168 -137 -23 0 -145
121 -145 144 0 17 26 46 42 46 6 0 32 -22 59 -49 l48 -49 95 89 c53 49 102 89
109 89 7 0 18 -5 25 -12z m816 -150 c8 -13 8 -23 0 -35 -10 -17 -40 -18 -342
-21 l-332 -2 -6 25 c-14 55 -11 56 344 53 297 -3 326 -5 336 -20z m-820 -274
c39 -15 17 -52 -95 -156 -61 -57 -119 -104 -130 -106 -14 -3 -39 17 -84 65
-65 69 -75 89 -53 111 21 21 43 13 88 -33 24 -25 47 -45 50 -45 3 0 46 38 95
85 90 84 100 90 129 79z m820 -156 c8 -13 8 -23 0 -35 -10 -16 -39 -18 -334
-21 -332 -2 -350 0 -350 37 0 40 12 41 349 39 296 -3 325 -5 335 -20z'
        />
      </g>
    </svg>
  );
};

export default ItemListActiveIcon;
